import type { GameState, MarketEventResponseOption } from './types';

const clone = <T,>(value: T): T => structuredClone(value);

function optionFor(event: GameState['activeMarketEvents'][number], optionId: string): MarketEventResponseOption | undefined {
  return (event.options ?? []).find((option) => option.id === optionId);
}

export function resolveMarketEventResponse(state: GameState, eventId: string, optionId: string): GameState {
  const next = clone(state);
  const event = next.activeMarketEvents.find((item) => item.id === eventId);
  if (!event) throw new Error('市场事件已结束');
  if (event.resolvedOptionId) throw new Error('这个市场事件已经响应过了');
  const option = optionFor(event, optionId);
  if (!option) throw new Error('无效的市场事件应对方案');
  if (next.cash < option.cashCost) throw new Error(`现金不足，还差 ${Math.ceil(option.cashCost - next.cash).toLocaleString('zh-CN')} 元`);

  next.cash -= option.cashCost;
  next.reputation = Math.max(0, Math.min(100, next.reputation + option.reputationDelta));
  if (option.effectPatch.multiplier !== undefined) {
    event.effect = { ...event.effect, multiplier: option.effectPatch.multiplier } as typeof event.effect;
  }
  event.weeksRemaining = Math.max(1, Math.min(8, event.weeksRemaining + option.durationDelta));
  event.resolvedOptionId = option.id;
  const summary = `${event.title}：${option.label}`;
  next.marketEventResolutions = [
    ...(next.marketEventResolutions ?? []),
    { eventId, optionId, resolvedWeek: next.week, summary },
  ].slice(-30);
  next.ledger.push({
    id: `ledger-${next.nextId++}`,
    week: next.week,
    category: 'operating_expense',
    cashAmount: -option.cashCost,
    profitAmount: -option.cashCost,
    objectId: eventId,
    label: option.cashCost > 0 ? `${summary}（投入 ${Math.ceil(option.cashCost).toLocaleString('zh-CN')}）` : summary,
  });
  next.updatedAt = Date.now();
  return next;
}
